import { render, staticRenderFns } from "./setWelcomeMessage.vue?vue&type=template&id=5ad762ca"
import script from "./setWelcomeMessage.vue?vue&type=script&lang=js"
export * from "./setWelcomeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports